import {dataTestId} from '@hconnect/uikit'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'
import React, {ReactNode, useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {PLANNING_COMMENTS_WIDGET_NAMESPACE} from '../consts'

interface ConfirmDialogMainAction {
  color?: 'error' | 'primary'
  text: string
  icon?: ReactNode
  onAction: () => void
}

interface ConfirmDialogDetails {
  title: string
  description: string
  mainAction: ConfirmDialogMainAction
}

interface ConfirmDialogState extends ConfirmDialogDetails {
  open: boolean
}

export const useConfirmDialog = () => {
  const {t} = useTranslation(PLANNING_COMMENTS_WIDGET_NAMESPACE)
  const [dialogState, setDialogState] = useState<ConfirmDialogState | null>(null)

  const openDialog = useCallback((details: ConfirmDialogDetails) => {
    setDialogState({...details, open: true})
  }, [])

  const closeDialog = useCallback(() => {
    setDialogState(null)
  }, [])

  const ConfirmDialog = dialogState?.open ? (
    <Dialog open onClose={closeDialog}>
      <DialogTitle>{dialogState.title}</DialogTitle>
      <DialogContent>
        <Typography>{dialogState.description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button
          color={dialogState.mainAction.color ?? 'primary'}
          onClick={() => {
            dialogState.mainAction.onAction()
            closeDialog()
          }}
          startIcon={dialogState.mainAction.icon}
          {...dataTestId('confirm_dialog_main_action_button')}
        >
          {dialogState.mainAction.text}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null

  return {openDialog, closeDialog, ConfirmDialog}
}
